import Raven from '@Raven';
import { _switchHydraEndpoint } from '../APIs';
import { Country } from '@Configs/Country';
import { isLocalhost } from '@Configs/ConfigsHeader';

export const getFooter = () => {
    return Raven.get(`https://member-calls2${isLocalhost() ? '-dev' : ''}.unicity.com/footer/data/public/${Country.getCode3()}`)
}

export const getOnlineCountry = () => {
    return Raven.get(`https://member-calls2.unicity.com/unishop-fn-misc/key_value/ushop_online_country`)
}